import { OverlayTrigger, Popover } from "react-bootstrap";
import { Celula, Chip } from "./style";

interface IProps {
  itens: string[];
  maxVisiveis?: number;
  larguraPopover?: number;
  vazio?: string;
}

export function ChipMais({
  itens,
  maxVisiveis = 1,
  larguraPopover = 220,
  vazio = "-",
}: IProps) {
  const lista = (itens ?? []).filter(Boolean);
  if (!lista.length) return <>{vazio}</>;

  const visiveis = lista.slice(0, maxVisiveis);
  const extras = lista.length - maxVisiveis;

  const popover = (
    <Popover id="popover-chip-mais" style={{ minWidth: larguraPopover }}>
      <Popover.Body style={{ padding: 12 }}>
        <div style={{ border: "1px solid #dee2e6", borderRadius: 4, overflow: "hidden" }}>
          {lista.map((item, i) => (
            <div
              key={i}
              style={{
                padding: "8px 14px",
                fontSize: "0.85rem",
                borderBottom: i < lista.length - 1 ? "1px solid #f0f0f0" : "none",
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <Celula>
      <span className="texto">{visiveis.join(", ")}</span>
      {extras > 0 && (
        <OverlayTrigger placement="top" trigger={["hover", "focus"]} overlay={popover}>
          <Chip>+{extras}</Chip>
        </OverlayTrigger>
      )}
    </Celula>
  );
}
